
export default {
  name: "hyperItem",
  props: [
    "item",
    "compact",
    "display",
    "element",
    "carousel"
  ],
  data() {
    return {
      bundle: this.element !== undefined ? this.element.bundle : false,
    };
  },
  methods: {
    increase() {
      this.item.quantity++;
      this.$forceUpdate();
    },
    decrease() {
      if (this.item.quantity == 1) {
        return;
      }
      this.item.quantity--;
      this.$forceUpdate();
    },
    addCart() {
      this.$hyperCart.addToCart(this.item, this.$hyperCart.getCart());
      $nuxt.$emit("updateCart", "updated");
    },
  },
};
